import React from 'react';
import { Switch } from 'react-router-dom';

import AuthorizedRoute from '../../_helpers/authorized.route';
import ContainerLayout from '../../_layouts/Container/';
import ContainerFluidLayout from '../../_layouts/ContainerFluid/';
import { Role } from '../../_helpers/role';

import QuestionnairesList from './List/';
import QuestionnairesCreate from './Create';
import QuestionnairesEdit from './Edit/';

export default () => {
  return (
    <Switch>
      <AuthorizedRoute path="/questionnaires/:id/edit" layout={ContainerFluidLayout} component={QuestionnairesEdit} />
      <AuthorizedRoute path="/questionnaires/create" layout={ContainerFluidLayout} component={QuestionnairesCreate} />
      <AuthorizedRoute path="/" layout={ContainerLayout} component={QuestionnairesList} />
    </Switch>
  );
}